
import Explain from '@/components/info/Explain.vue';
import { computed, defineComponent } from 'vue';
import { useCalculationState } from '@/lib/calculationstate';
import NVAbbr from '@/components/NVAbbr.vue';
import params from '@/lib/calculationparams';
import { format as formatCurrency } from '@/lib/currency';
import { calculatePremium } from '@/lib/calculations/nvschade';

export default defineComponent({
  name: 'InsuranceInfo',
  components: {
    NVAbbr,
    Explain,
  },
  setup() {
    const state = useCalculationState();

    const uwvMax = formatCurrency(params.uwv.maximumSalary);
    const nvExcMax = formatCurrency(params.nvschade.excedentMaximum);
    const nvExcTopMax = formatCurrency(params.nvschade.excedentTopMaximum);

    const premium = computed(() => formatCurrency(calculatePremium(state)));

    return {
      state,

      uwvMax,
      nvExcMax,
      nvExcTopMax,

      premium,
    };
  },
});

